<template>
<div>
    <div class="mobile-contact-bg">
     <baidu-map
        :center="{lng: '118.187327',lat: '26.641729'} "
        :zoom="18"
        :scroll-wheel-zoom="true"
        style="width:100%;height:320px;position: relative;top: -8px;"
      >
      <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation>
        <bm-marker :position="{lng: '118.187327', lat: '26.641729'}" >
          <bm-label
            :content="'冠林大厦'"
            :labelStyle="{color: 'red', fontSize : '12px'}"
            :offset="{width: 0, height: -30}"
          />
        </bm-marker>
      </baidu-map>
    </div>
    <div class="mobile-contact-form">
      <bs-detail :meta="{ module:'single-article', field:'contact' }" :is-loading="true">
        <template slot="data" slot-scope="slot">
          <p>
            <img src="../../assets/mobile/youxiagn@2x.png">
            <span class="span-title">邮箱</span>
            <span class="span-content" v-text="slot.data.email"></span>
          </p>
          <p>
            <img src="../../assets/mobile/dianhua@2x.png">
            <span class="span-title">手机</span>
            <span class="span-content" v-text="slot.data.telephone"></span>
          </p>
          <p>
            <img src="../../assets/mobile/dizhi@2x.png">
            <span class="span-title">地址</span>
            <span class="span-content" v-text="slot.data.address"></span>
          </p>
        </template>
      </bs-detail>
    </div>
    <div class="mobile-contact-qrcode">
      <img src="../../assets/mobile/qrcode@2x.png">
    </div>
    <!-- <mobile-footer></mobile-footer> -->
</div>
</template>
<script>
require("../../styles/mobile/mobile-arti-single-contact-us.scss");
import Vue from "vue";
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: "9862E14DE5d6373de36cd8e91503044b"
});
export default {
  name: "mobile-arti-single-contact-us",
  data() {
    return {};
  },
  props: {
    result: {
      type: Object
    }
  },
  mounted() {},
  components: {
    BsDetail: () => import("../../components/bs-detail"),
    mobileFooter: () => import("./mobile-footer")
  },
  methods: {},
  computed: {}
};
</script>
